import TabList from '../tabList/tabList.js';
import PanelList from '../panelList/panelList.js';
import reducer from '../utils/stateManagement/reducer.js';
import Api from '../utils/api/api.js';
import useDynTabs from './useDynamicTabs.js';
import { ApiContext, StateContext, ForceUpdateContext } from '../utils/context.js';

var getDeps = function getDeps() {
  var getApiInstance = function getApiInstance(options) {
    return new Api({
      options: options
    });
  };

  return {
    reducer: reducer,
    getApiInstance: getApiInstance,
    PanelList: PanelList,
    TabList: TabList,
    ApiContext: ApiContext,
    StateContext: StateContext,
    ForceUpdateContext: ForceUpdateContext
  };
};

export default useDynTabs.bind(null, getDeps);